<template>
  <validation-provider
    v-slot="{ valid, errors, untouched }"
    ref="validator"
    :vid="inputId"
    :name="$attrs.name"
    :rules="rules"
  >
    <b-form-group
      :id="inputId + '-group'"
      :label="label"
      :label-for="inputId"
    >
      <b-form-file
        :id="inputId"
        ref="file"
        v-model="inputValue"
        :name="$attrs.name || label"
        :state="untouched || (errors[0] ? false : (valid ? true : null))"
        :placeholder="inputValue && inputValue.name ? inputValue.name : 'choose_file_placeholder' | i18n"
        :drop-placeholder="'drop_file_placeholder' | i18n"
        :browse-text="'browse' | i18n"
        :accept="fileExtensions"
        size="sm"
      />
      <b-form-invalid-feedback id="inputLiveFeedback">
        {{ errors[0] }}
      </b-form-invalid-feedback>
    </b-form-group>
  </validation-provider>
</template>

<script>
import {ValidationProvider} from 'vee-validate';
import {BFormFile} from 'bootstrap-vue';

export default {
  name: 'ValidatedFileInput',
  components: {ValidationProvider, BFormFile},
  props: {
    inputId: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    rules: {
      type: [Object, String],
      default: ''
    },
    fileExtensions: {
      type: String,
      default: ''
    },
    value: {
      type: File,
      default: () => null
    }
  },
  data: () => ({
    inputValue: null
  }),
  watch: {
    inputValue(newVal) {
      this.$emit('input', newVal);
    },
    value(newVal) {
      this.inputValue = newVal;
    }
  },
  created() {
    if (this.value) {
      this.inputValue = this.value;
    }
  }
};
</script>
